import { useMemo } from "react";
import { ReportSummary } from "../@types";
import { CanvasRows } from "../components/layout-editor/@types";
import { useGetLayoutDetails } from "../components/layout-editor/hooks";
import { COMPONENTS_MAP } from "../components/report_summary/consts";
import useGetReportSummary from "./useGetReportSummary";
import useGetSelectedLayout from "./useGetSelectedLayout";
import useLocalSampleSummaryParams from "./useLocalSampleSummaryParams";

const getFilteredLayouts = (layout?: CanvasRows, report?: ReportSummary) => {
  if (!layout || !report) return [];
  return layout.filter(
    ({ components }) =>
      components.filter(id => {
        const { Component, filterFn } = COMPONENTS_MAP[id] ?? {};
        if (!Component) return false;
        return !filterFn || filterFn(report);
      }).length
  );
};

const useGetSelectedLayoutDetails = () => {
  const { hash, sourceId, relationshipId } = useLocalSampleSummaryParams();

  const { data: report, isLoading } = useGetReportSummary(
    hash,
    sourceId,
    relationshipId
  );

  const selectedLayout = useGetSelectedLayout();
  const { data: layoutDetails, isPending } = useGetLayoutDetails(
    selectedLayout?.id,
    selectedLayout?.type
  );

  const filteredLayout = useMemo(
    () => getFilteredLayouts(layoutDetails?.layout, report),
    [layoutDetails?.layout, report]
  );

  return {
    layoutDetails: filteredLayout,
    isLoading: isLoading || isPending,
    selectedLayout
  };
};

export default useGetSelectedLayoutDetails;
